import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';

/**
 * Guard de rotas admin (/plans-admin).
 * Se não estiver logado → redireciona pra /login-admin?returnTo=<url>
 * Se logado mas sem role admin/superadmin → mesma coisa.
 */
export default function PrivateAdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  const isAdmin = user?.role === 'admin' || user?.role === 'superadmin';
  if (!user || !isAdmin) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login-admin?returnTo=${returnTo}`} replace />;
  }

  return children;
}
